(function ($) {

    // Init Foundation
    $(document).foundation();

    // Menu icon
    $('[data-responsive-toggle]').on('toggled.zf.responsiveToggle', function () {
        var body = $("body"), button = $('button.hamburger');
        if (body.hasClass("menu-open")) {
            body.removeClass("menu-open");
            button.removeClass('is-active');
        } else {
            body.addClass("menu-open");
            button.addClass('is-active');
        }
    });

    // Image pop-ups
    $('a[href*=".jpg"], a[href*=".jpeg"], a[href*=".png"], a[href*=".gif"]').each(function () {
        if ($(this).parents('.gallery').length == 0) {
            $(this).magnificPopup({
                type: 'image',
                closeOnContentClick: true,
                image: {
                    titleSrc: function (item) {
                        var cpt = item.el.find('img').attr('data-caption')
                        return typeof cpt != "undefined" ? cpt : "";
                    }
                }
            });
        }
    });

    // Gallery pop-ups
    $('.gallery').each(function () {
        $(this).magnificPopup({
            delegate: 'a',
            type: 'image',
            image: {
                titleSrc: function (item) {
                    var cpt = item.el.find('img').attr('data-caption')
                    return typeof cpt != "undefined" ? cpt : "";
                }
            },
            gallery: {enabled: true}
        });
    });

    // Frontpage slider
    var bg_container = $('.background-images');
    if (bg_container.length > 0) {

        var imgs = bg_container.find('.image'),
            first = imgs.first();


        // Don't slide if zero or just one image
        if (imgs.length > 1) {

            setInterval(function () {
                var active = bg_container.find('.active'),
                    next = active.next('.image')

                if (next.length === 0) {
                    next = first;
                }

                active.removeClass('active');
                next.addClass('active');

            }, 7000);

        }

    }

    // Smooth scroll
    $("a").on('click', function (e) {
        if (this.hash !== "" && this.pathname === window.location.pathname) {
            e.preventDefault();
            var hash = this.hash;

            $('html, body').animate({
                scrollTop: $(hash).offset().top - 50
            }, 800, function () {
                if (history.replaceState) {
                    window.history.replaceState(null, null, hash);
                } else {
                    window.location.hash = hash;
                }
            });
        }
    });

})(jQuery);
